import * as Yup from "yup";

export const existingJdOption = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const genderOptions = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
];

export const statusList = [
  { label: "Open", value: "OPEN" },
  { label: "Close", value: "CLOSED" },
  { label: "On hold", value: "ON_HOLD" },
];

export const JobTypeList = [
  {
    value: "Full-time",
    label: "Full Time",
  },
  {
    value: "Part-time",
    label: "Part Time",
  },
  {
    value: "Contract",
    label: "Contract",
  },
  {
    value: "Internship",
    label: "Internship",
  },
];

export const resignValidationSchema = (deprovisionStatus: any, isUpdate?: boolean) =>
  Yup.object().shape({
    lastWorkingDay: isUpdate || deprovisionStatus?.toLowerCase() === "rejected" ? Yup.string().notRequired() : Yup.string().required("Last working day is required"),
    reason: deprovisionStatus?.toLowerCase() === "rejected" ? Yup.string().required("Reason is required") : Yup.string().notRequired(),
    trfGeneration: Yup.boolean(),
    personsRequired: Yup.number().when("trfGeneration", {
      is: true,
      then: (schema) => schema.typeError("Must be a number").required("Persons Required is required"),
    }),
    ctc: Yup.string().when("trfGeneration", {
      is: true,
      then: (schema) => schema.required("CTC is required"),
    }),

    educationBackground: Yup.string().when("trfGeneration", {
      is: true,
      then: (schema) => schema.required("Education background is required"),
    }),
    experienceRequired: Yup.string().when("trfGeneration", {
      is: true,
      then: (schema) => schema.required("Experience is required"),
    }),
    lastIncumbent: Yup.string().when("trfGeneration", {
      is: true,
      then: (schema) => schema.required("Last incumbent is required"),
    }),
    positionFillDate: Yup.string().when("trfGeneration", {
      is: true,
      then: (schema) => schema.required("Position fill last date is required"),
    }),
    existingJD: Yup.string().when("trfGeneration", {
      is: true,
      then: (schema) => schema.required("Existing job description is required"),
    }),
    jobType: Yup.string().when("trfGeneration", {
      is: true,
      then: (schema) => schema.required("Job Type is required"),
    }),
  });

export const resignationInitialValues = {
  lastWorkingDay: "",
  trfGeneration: false,
  reason: "",
  // TRF Form
  roleDescription: "",
  requisitionNo: "",
  company: "",
  positionTitle: "",
  department: "",
  reportingPerson: "",
  personsRequired: 1,
  ctc: "",
  gender: null,
  ageGroup: null,
  educationBackground: "",
  experienceRequired: "",
  lastIncumbent: "",
  positionFillDate: "",
  existingJD: "",
  additionalInput: "",
  preparedBy: "",
  approvedBy: "",
  jobType: "",
};

interface FunctionProps {
  [key: string]: any;
}
export const createPayload = ({ organisationId, designationName, designationId, reportingManagerId, values, employeeId }: FunctionProps) => ({
  organisationId: Number(organisationId),
  jobTitle: designationName,
  designation: {
    designationId: Number(designationId),
  },
  hiringManagerId: Number(reportingManagerId),
  numPositions: Number(values?.personsRequired),
  gender: values?.gender,
  ageGroup: values.ageGroup,
  jobType: values?.jobType,
  requiredSkills: values?.additionalInput,
  salaryRange: values?.ctc,
  expectedDateOfJoining: values?.positionFillDate,
  status: "Open",
  createdBy: {
    employeeId: Number(reportingManagerId),
  },
  requisitionNo: values?.requisitionNo,
  educationBackground: values?.educationBackground,
  experienceRequired: values?.experienceRequired,
  isJdExists: values?.existingJD,
  incumbentName: values?.lastIncumbent,
  reportingPerson: values?.reportingPerson,
  preparedBy: values?.reportingPerson,
});

export const trfFormApiCall = async (props: FunctionProps) => {
  const { payload, trfFormApi, setModalOpen, setModalResponse, setModalMessage, handleClosePopUpModal, navigate, setLoader } = props;
  setLoader(true);
  const pathParams = {
    path: "",
  };
  try {
    const response: any = await trfFormApi(payload, {}, pathParams);
    if (response?.status === 200) {
      // setModalOpen(true);
      // setModalResponse("success");
      // setModalMessage("Resignation Approved and TRF Form submitted successfully");
      setTimeout(() => {
        setLoader(false);
        // handleClosePopUpModal();
        navigate("/exit-interview-success?message=Resignation request approved successfully!");
      }, 2000);
    }
  } catch (err: any) {
    setLoader(false);
    setModalOpen(true);
    setModalResponse("error");
    setModalMessage(err?.message ?? "Something went wrong");
    setTimeout(() => {
      handleClosePopUpModal();
    }, 2000);
  }
};

export const getEmployeeDetails = async (props: FunctionProps) => {
  const {
    employeeApiKey,
    setLoader,
    employeeId,
    getEmployeeDetailsApi,
    setInitialValues,
    initialValues,
    setModalResponse,
    setModalMessage,
    deprovisionStatus,
    handleClosePopUpModal,
    setModalOpen,
    setIsSubmitted,
  } = props;
  setLoader(true);
  const pathParam = {
    param: `${employeeId}/deprovision?deprovisionStatus=${deprovisionStatus}&apikey=${employeeApiKey}`,
  };
  try {
    const response: any = await getEmployeeDetailsApi("", {}, pathParam);
    const data = response?.data?.data;
    console.log(" data:", data);
    setInitialValues({
      ...initialValues,
      employeeName: data?.firstName + " " + data?.lastName || "",
      lastWorkingDay: data?.relievingDate || "",
      reportingPerson: data?.reportingManager?.firstName + " " + data?.reportingManager?.lastName || "",
      department: data?.department?.name || "",
      designationName: data?.designation?.name || "",
      positionTitle: data?.designation?.name || "",
      employeeCode: data?.code || "",
      company: data?.organisationName || "",
    });
    setLoader(false);
  } catch (err: any) {
    setLoader(false);
    if (err.response.status === 404) {
      setIsSubmitted(true);
    } else {
      setModalOpen(true);
      setModalResponse("error");
      setModalMessage(err?.message ?? "Something went wrong");
      setTimeout(() => {
        handleClosePopUpModal();
      }, 2000);
    }
  }
};
